import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { addInterpreter } from 'slices/interpreterSlice';
import { interpreterSelector } from 'slices/interpreterSlice';
import ErrorMessage from 'components/common/ErrorMessage';
import { setError } from 'slices/interpreterSlice';
import toast from 'react-hot-toast';
import { updateInterpreter } from 'slices/interpreterSlice';
import Api from "services/api"
import { CustomSwitch } from 'components/common/Switch';
import { stateSelector } from 'slices/stateSlice';
import { citySelector } from 'slices/citySlice';
import { Select } from 'components/common/Select';
import { fetchLanguages } from 'slices/languageSlice';
import { fetchStates } from 'slices/stateSlice';
import { fetchCountries } from 'slices/countrySlice';
import { fetchTimezone } from 'slices/timezoneSlice';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import PhoneInput from 'components/common/PhoneInput';
import { Switch } from '@mui/material';
import { AsyncPaginate } from 'react-select-async-paginate';
import { selectCustomStyles } from 'components/common/Select';
import { useNavigate } from 'react-router-dom';
import FullPageLoader from 'components/common/FullPageLoader';
import { usePermissions } from 'layouts/Admin';
import InterpreterRateSection from './InterpreterRateSection';
import { USA } from "constants/common";
const apiService = new Api();

const AddInterpreter = ({ item }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const { checkPermission } = usePermissions()
  const { register, handleSubmit, watch, formState: { errors }, control, setValue, clearErrors } = useForm();
  const { error, loader } = useSelector(interpreterSelector);
  const [status, setStatus] = useState(1)
  const { state: states } = useSelector(stateSelector);
  const { city: cities } = useSelector(citySelector);
  const [credentialsSend, setCredentialsSend] = useState(0);
  const [autoAssign, setAutoAssign] = useState(false);
  const [allCountries, setAllCountries] = useState([]);
  const [allTimezone, setAllTimezone] = useState([]);
  const [filterStates, setfilterStates] = useState({
    label: "",
    value: ""
  })
  const [allStates, setAllStates] = useState([]);
  const [filterCountries, setfilterCountries] = useState({
    label: "",
    value: ""
  })
  const [availableTimezones, setAvailableTimezones] = useState([]);
  const [filterTimezones, setFilterTimezones] = useState({
    label: "",
    value: ""
  })
  const [timezoneDisable, setTimezoneDisable] = useState(false);

  const country_name = filterCountries?.label || '';

  const country_id = filterCountries?.value || '';
  const state_id = watch("state_id") ?? item?.state_id;
  const city_name = watch("city_name");

  const clearAll = () => {
    setValue('code', '');
    setValue('first_name', '');
    setValue('last_name', '');
    setValue('email', '')
    setValue('password', '');
    setValue('phone', '');
    setValue('secondary_number', '');
    setValue('secondary_email', '');
    setValue('zip_code', '');
    setAutoAssign(false);
    setCredentialsSend(0);
    setValue('us_based', false);
    setValue('non_us_based', false);
    setValue('english_to_target', false);
    setValue('spanish_to_target', false);
    setValue('court_certified', false);
    setValue('medical_certified', false);
    setValue("language_ids", [])
    setStatus(1)
    setValue('normal_hour_start_time', '')
    setValue('normal_hour_end_time', '')
    setValue('after_hour_start_time', '')
    setValue('after_hour_end_time', '')
    setValue('grace_period', '')
    setValue('general_opi_vri_normal_rate', '')
    setValue('general_opi_vri_normal_rate_time_unit', 'hour')
    setValue('general_inperson_normal_rate', '')
    setValue('general_inperson_normal_rate_time_unit', 'hour')
    setValue('general_opi_vri_after_rate', '')
    setValue('general_opi_vri_after_rate_time_unit', 'hour')
    setValue('general_inperson_after_rate', '')
    setValue('general_inperson_after_rate_time_unit', 'hour')
    setValue('general_opi_vri_normal_min', '')
    setValue('general_opi_vri_normal_min_time_unit', 'hour')
    setValue('general_inperson_normal_min', '')
    setValue('general_inperson_normal_min_time_unit', 'hour')
    setValue('general_opi_vri_after_min', '')
    setValue('general_opi_vri_after_min_time_unit', 'hour')
    setValue('general_inperson_after_min', '')
    setValue('general_inperson_after_min_time_unit', 'hour')
    setValue('court_opi_vri_normal_rate', '')
    setValue('court_opi_vri_normal_rate_time_unit', 'hour')
    setValue('court_inperson_normal_rate', '')
    setValue('court_inperson_normal_rate_time_unit', 'hour')
    setValue('court_opi_vri_after_rate', '')
    setValue('court_opi_vri_after_rate_time_unit', 'hour')
    setValue('court_inperson_after_rate', '')
    setValue('court_inperson_after_rate_time_unit', 'hour')
    setValue('court_opi_vri_normal_min', '')
    setValue('court_opi_vri_normal_min_time_unit', 'hour')
    setValue('court_inperson_normal_min', '')
    setValue('court_inperson_normal_min_time_unit', 'hour')
    setValue('court_opi_vri_after_min', '')
    setValue('court_opi_vri_after_min_time_unit', 'hour')
    setValue('court_inperson_after_min', '')
    setValue('court_inperson_after_min_time_unit', 'hour')
    setValue('country_id', '')
    setValue('state_id', '')
    setValue('city_name', '')
    setValue("timezone_id", "");
  }


  useEffect(() => {
    setValue('code', item?.code || '');
    setValue('first_name', item?.first_name || '');
    setValue('last_name', item?.last_name || '');
    setValue('email', item?.user?.email || '')
    setValue('phone', item?.phone || '');
    setValue('secondary_number', item?.secondary_number || undefined);
    setValue('secondary_email', item?.secondary_email || undefined);
     setValue('country_id', item?.country_id)
    setValue('city_name', item?.city_name || '');
    setValue('zip_code', item?.zip_code || '');
     setValue('state_id', item?.state_id)
    setValue('timezone_id', item?.timezone_id || '');
    setCredentialsSend((typeof (item?.user?.credentials_send) == "number") ? item?.user?.credentials_send : 0);
    setAutoAssign((typeof (item?.auto_assign) == "number") ? item?.auto_assign : 0);

    setValue('us_based', item?.filters?.us_based == 1 ? true : false || false);
    setValue('non_us_based', item?.filters?.non_us_based == 1 ? true : false || false);
    setValue('english_to_target', item?.filters?.english_to_target == 1 ? true : false || false);
    setValue('spanish_to_target', item?.filters?.spanish_to_target == 1 ? true : false || false);
    setValue('court_certified', item?.filters?.court_certified == 1 ? true : false || false);
    setValue('medical_certified', item?.filters?.medical_certified == 1 ? true : false || false);

    setValue("language_ids", item?.languages?.map(language => language.language_id) || [])
    setStatus((typeof (item?.status) == "number") ? item?.status : 1)

    setValue('normal_hour_start_time', item?.interpreter_rates?.normal_hour_start_time || '')
    setValue('normal_hour_end_time', item?.interpreter_rates?.normal_hour_end_time || '')
    setValue('after_hour_start_time', item?.interpreter_rates?.after_hour_start_time || '')
    setValue('after_hour_end_time', item?.interpreter_rates?.after_hour_end_time || '')
    setValue('grace_period', item?.interpreter_rates?.grace_period || '')
    setValue('general_opi_vri_normal_rate', item?.interpreter_rates?.general_opi_vri_normal_rate || '')
    setValue('general_opi_vri_normal_rate_time_unit', item?.interpreter_rates?.general_opi_vri_normal_rate_time_unit || 'hour')
    setValue('general_inperson_normal_rate', item?.interpreter_rates?.general_inperson_normal_rate || '')
    setValue('general_inperson_normal_rate_time_unit', item?.interpreter_rates?.general_inperson_normal_rate_time_unit || 'hour')
    setValue('general_opi_vri_after_rate', item?.interpreter_rates?.general_opi_vri_after_rate || '')
    setValue('general_opi_vri_after_rate_time_unit', item?.interpreter_rates?.general_opi_vri_after_rate_time_unit || 'hour')
    setValue('general_inperson_after_rate', item?.interpreter_rates?.general_inperson_after_rate || '')
    setValue('general_inperson_after_rate_time_unit', item?.interpreter_rates?.general_inperson_after_rate_time_unit || 'hour')
    setValue('general_opi_vri_normal_min', item?.interpreter_rates?.general_opi_vri_normal_min || '')
    setValue('general_opi_vri_normal_min_time_unit', item?.interpreter_rates?.general_opi_vri_normal_min_time_unit || 'hour')
    setValue('general_inperson_normal_min', item?.interpreter_rates?.general_inperson_normal_min || '')
    setValue('general_inperson_normal_min_time_unit', item?.interpreter_rates?.general_inperson_normal_min_time_unit || 'hour')
    setValue('general_opi_vri_after_min', item?.interpreter_rates?.general_opi_vri_after_min || '')
    setValue('general_opi_vri_after_min_time_unit', item?.interpreter_rates?.general_opi_vri_after_min_time_unit || 'hour')
    setValue('general_inperson_after_min', item?.interpreter_rates?.general_inperson_after_min || '')
    setValue('general_inperson_after_min_time_unit', item?.interpreter_rates?.general_inperson_after_min_time_unit || 'hour')
    setValue('court_opi_vri_normal_rate', item?.interpreter_rates?.court_opi_vri_normal_rate || '')
    setValue('court_opi_vri_normal_rate_time_unit', item?.interpreter_rates?.court_opi_vri_normal_rate_time_unit || 'hour')
    setValue('court_inperson_normal_rate', item?.interpreter_rates?.court_inperson_normal_rate || '')
    setValue('court_inperson_normal_rate_time_unit', item?.interpreter_rates?.court_inperson_normal_rate_time_unit || 'hour')
    setValue('court_opi_vri_after_rate', item?.interpreter_rates?.court_opi_vri_after_rate || '')
    setValue('court_opi_vri_after_rate_time_unit', item?.interpreter_rates?.court_opi_vri_after_rate_time_unit || 'hour')
    setValue('court_inperson_after_rate', item?.interpreter_rates?.court_inperson_after_rate || '')
    setValue('court_inperson_after_rate_time_unit', item?.interpreter_rates?.court_inperson_after_rate_time_unit || 'hour')
    setValue('court_opi_vri_normal_min', item?.interpreter_rates?.court_opi_vri_normal_min || '')
    setValue('court_opi_vri_normal_min_time_unit', item?.interpreter_rates?.court_opi_vri_normal_min_time_unit || 'hour')
    setValue('court_inperson_normal_min', item?.interpreter_rates?.court_inperson_normal_min || '')
    setValue('court_inperson_normal_min_time_unit', item?.interpreter_rates?.court_inperson_normal_min_time_unit || 'hour')
    setValue('court_opi_vri_after_min', item?.interpreter_rates?.court_opi_vri_after_min || '')
    setValue('court_opi_vri_after_min_time_unit', item?.interpreter_rates?.court_opi_vri_after_min_time_unit || 'hour')
    setValue('court_inperson_after_min', item?.interpreter_rates?.court_inperson_after_min || '')
    setValue('court_inperson_after_min_time_unit', item?.interpreter_rates?.court_inperson_after_min_time_unit || 'hour')

  }, [item]);

useEffect(() => {
  // Set default values if not already set
  setValue("normal_hour_start_time", "08:00"); // 8 AM
  setValue("normal_hour_end_time", "21:00");   // 9 PM

}, [setValue]);

  const submitCallback = (status, message) => {
    if (status) {
      toast.success(message, {
        className: "successToast",
      })
      clearAll()
      navigate(-1)
    }
    else {
      console.log('onSubmit', error)
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };


  const onSubmit = (data) => {
    
    console.log("data", data)
    dispatch(setError({}))
    data = {
      ...data,
      credentialsSend,
      autoAssign,
      status,
    };
    if (item?.id) {
      dispatch(updateInterpreter(data, item?.id, submitCallback));
    } else
      dispatch(addInterpreter(data, submitCallback));

  }


  

  // #region Country dropdown

   useEffect(() => {
    dispatch(fetchCountries(1, { id: item?.country?.id }))
    if (item?.country?.name && item?.country?.id) {
      setfilterCountries({
        label: item?.country?.name || "",
        value: item?.country?.id || ""
      })
    } else {
      setfilterCountries(null)
    }
  }, [item?.country])
  

  const filteredCountriesLoadOptions = async (inputValue, loadedOptions, { page }) => {
    const result = await dispatch(fetchCountries(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
  
    setAllCountries(result?.data)
    return {
      options: result.data.map(val => ({
        value: val.id,
        label: val.name,
      })),

      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };
  //#endregion

  

  // #region States dropdown

  useEffect(() => {
    dispatch(fetchStates(1, { id: item?.state?.id }))
    if (item?.state?.name && item?.state?.id) {
      setfilterStates({
        label: item?.state?.name || "",
        value: item?.state?.id || ""
      })
    } else {
      setfilterStates(null)
    }
  }, [item?.state])


  const filteredStatesLoadOptions = async (inputValue, loadedOptions, { page }) => {
    const result = await dispatch(fetchStates(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
    setAllStates(result?.data)
    return {
      options: result.data.map(val => ({
        value: val.id,
        label: val.name,
      })),

      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };
  //#endregion


  // #region City dropdown
  const [allCities, setAllCities] = useState([])
  const [selectedCity, setSelectedCity] = useState({
    label: "",
    value: ""
  })
  const filteredCities = React.useMemo(() =>
    allCities?.map(val => {
      const object = {
        label: item?.city?.name || val.name,
        value: item?.city?.id || val.id,
      }
      return object
    }), [allCities, item?.city]);


  const filteredStates = React.useMemo(() => {

    setAllCities(item?.state?.name != null ? states?.find(state => state?.name == item?.state?.name)?.cities : [])
    return states?.map(item => {
      const object = {
        label: item?.name,
        value: item?.id,
      }
      return object
    })
  }, [states, item?.state?.name]);

  useEffect(() => {
    setSelectedCity(filteredCities)
  }, [filteredCities])

  useEffect(() => {
    if (item?.city?.name && item?.city?.id) {
      setSelectedCity({
        label: item?.city?.name || "",
        value: item?.city?.id || ""
      })
    } else {
      setSelectedCity(null)
    }
  }, [item?.city])

  //#endregion


  // #region Language dropdown
  const [languageState, setLanguageState] = useState({
    label: "",
    value: ""
  })

  useEffect(() => {
    setLanguageState(
      item?.languages?.map(val => ({
        label: val?.language?.name || "",
        value: val?.language?.id || ""
      }))
    );
  }, [item?.languages]);


 


  const filteredLanguagesLoadOptions = async (inputValue, loadedOptions, { page }) => {
    const result = await dispatch(fetchLanguages(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
    return {
      options: result?.data?.map(language => ({
        value: language.id,
        label: language.name,
      })),
      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };
  //#endregion
  
  
  // #region Timezone dropdown
  


useEffect(() => {
  const fetchAndSetTimezone = async () => {
  

    if (!country_name) {
      setAvailableTimezones([]);
      setFilterTimezones(null);
      setValue("timezone_id", "");
      setTimezoneDisable(false);
      return;
    }

    try {
      const response = await dispatch(
        fetchTimezone(1, { country_id, state_id }, true, true)
      );
      const timezones = response?.data || [];

      const tzOptions = timezones.map(tz => ({
        value: tz.id,
        label: tz.display_name,
      }));

      setAvailableTimezones(tzOptions);

      // US selected, state also selected
      if (country_name === USA && state_id) {
        
        if (tzOptions.length === 1) {
          setFilterTimezones(tzOptions[0]);
          setValue("timezone_id", tzOptions[0].value);
          setTimezoneDisable(true);
        } else {
          setFilterTimezones(null);
          setValue("timezone_id", "");
          setTimezoneDisable(false);
        }
      }
      // US selected, no state selected
      else if (country_name === USA) {
        
    
        setFilterTimezones(null);
        setValue("timezone_id", "");
        setTimezoneDisable(false);
      }
      // Any other country
      else {
        if (tzOptions.length === 1) {
          setFilterTimezones(tzOptions[0]);
          setValue("timezone_id", tzOptions[0].value);
          setTimezoneDisable(true);
        } else {
          setFilterTimezones(null);
          setValue("timezone_id", "");
          setTimezoneDisable(false);
        }
      }

    } catch (error) {
      console.error("Timezone fetch error:", error);
      setAvailableTimezones([]);
      setFilterTimezones(null);
      setValue("timezone_id", "");
      setTimezoneDisable(false);
    }
  };

  fetchAndSetTimezone();
}, [filterCountries, filterStates, setValue, dispatch]);



  // Load options function (API call to timezone endpoint)
const filteredTimezonesLoadOptions = async (inputValue, loadedOptions, { page }) => {
  

  const result = await dispatch(
    fetchTimezone(
      page,
      {
        pageLength: 10,
        sortBy: "id",
        sortDirection: "asc",
        search: inputValue,
        country_id,
        state_id,
      },
      true,
      true
    )
  );

  return {
    options: result.data.map(val => ({
      value: val.id,
      label: val.display_name,
    })),
    hasMore: page !== result?.last_page,
    additional: {
      page: page + 1,
    },
  };
};




  //#endregion

  const handleChangeSwitch = (value, onChange) => {
    onChange(value)
  }




  return (
    <>
      <form className="card_table p-4" onSubmit={handleSubmit(onSubmit)}>
        <div className="foam_page_row">
          {item?.id && (
            <div className="row-primary">
              <h2>Interpreter Code *</h2>
              <Controller
                name="code"
                control={control}
                render={({ field }) => (
                  <div className="w-100">
                    <input
                      className="input-in type_inp"
                      type="text"
                      name="code"
                      placeholder="Interpreter code"
                      readOnly
                      value={field.value}
                    />
                  </div>
                )}
              />
            </div>
          )}
          <div className="row-primary">
            <h2>First Name *</h2>
            <Controller
              name="first_name"
              rules={{
                required: "First name is required",
              }}
              control={control}
              render={({ field }) => (
                <div className="w-100">
                  <input
                    className="input-in type_inp"
                    type="text"
                    name="first-name"
                    placeholder="First name"
                    {...field}
                  />
                  {error?.errors?.first_name?.length > 0 &&
                    error?.errors?.first_name?.map((error) => (
                      <ErrorMessage text={error} />
                    ))}
                  {errors?.first_name?.message && (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.first_name?.message} />
                    </div>
                  )}
                </div>
              )}
            />
          </div>

          <div className="row-primary">
            <h2>Last Name</h2>
            <Controller
              name="last_name"
              control={control}
              render={({ field }) => (
                <input
                  className="input-in type_inp"
                  type="text"
                  name="last-name"
                  placeholder="Last name"
                  {...field}
                />
              )}
            />
          </div>

          <div className="row-primary">
            <h2>Email *</h2>
            <Controller
              name="email"
              rules={{
                required: "Email is required",
              }}
              control={control}
              render={({ field }) => (
                <div className="w-100">
                  <input
                    className={`input-in type_inp ${
                      error?.errors?.email ? "border-red" : ""
                    } `}
                    type="email"
                    name="email"
                    pattern={/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/}
                    placeholder="Email Address"
                    {...field}
                  />
                  {error?.errors?.email?.map((error) => (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={error} />
                    </div>
                  ))}
                  {errors?.email?.message && (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.email?.message} />
                    </div>
                  )}
                </div>
              )}
            />
          </div>

          <div className="row-primary">
            <h2>Password {!item && "*"}</h2>
            <div className="w-100">
              <Controller
                name="password"
                rules={
                  !item && {
                    required: "Password is required",
                  }
                }
                control={control}
                render={({ field }) => (
                  <input
                    className={`input-in type_inp `}
                    autoComplete="off"
                    type="password"
                    name="password"
                    placeholder="Password"
                    {...field}
                    disabled={watch("type") == "interpreter" ? true : false}
                  />
                )}
              />
              {error?.errors?.password?.map((error) => (
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={error} />
                </div>
              ))}
              {errors?.password?.message && (
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.password?.message} />
                </div>
              )}
            </div>
          </div>

          <div className="row-primary">
            <h2>Phone Number *</h2>

            <Controller
              name="phone"
              control={control}
              rules={{
                required: "Phone number is required",
              }}
              render={({ field }) => (
                <div className="w-100">
                  <PhoneInput
                    className="input-in type_inp"
                    type="tel"
                    name="phone"
                    placeholder="Phone number"
                    {...field}
                  />
                  {error?.errors?.phone?.map((error) => (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={error} />
                    </div>
                  ))}
                  {errors?.phone?.message && (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.phone?.message} />
                    </div>
                  )}
                </div>
              )}
            />
          </div>

          <div className="row-primary">
            <h2>Secondary Email</h2>
            <Controller
              name="secondary_email"
              control={control}
              render={({ field }) => (
                <input
                  className={`input-in type_inp ${
                    error?.errors?.secondary_email ? "border-red" : ""
                  } `}
                  type="email"
                  name="secondary_email"
                  pattern={/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/}
                  placeholder="Secondary email"
                  {...field}
                />
              )}
            />
          </div>

          <div className="row-primary">
            <h2>Secondary Number</h2>
            <Controller
              name="secondary_number"
              control={control}
              render={({ field }) => (
                <PhoneInput
                  className="input-in type_inp"
                  type="tel"
                  name="phone"
                  placeholder="Phone number"
                  {...field}
                />
              )}
            />
          </div>

          <div className="row-primary">
            <h2>Select Country *</h2>

            <Controller
              name="country_id"
              control={control}
              rules={{
                required: "Please select a country",
              }}
              render={({ field }) => (
                <div style={{ width: "100%" }}>
                  <AsyncPaginate
                    menuPlacement="auto"
                    styles={selectCustomStyles}
                    value={filterCountries}
                    loadOptions={filteredCountriesLoadOptions}
                    isClearable
                    escapeClearsValue
                    onChange={(obj) => {
                      setfilterCountries(obj);
                      field.onChange(obj?.value);
                      if (obj?.label != USA) {
                        setValue("state_id", "");
                        setValue("zip_code", "");
                      }
                    }}
                    additional={{
                      page: 1,
                    }}
                  />
                  {errors?.country_id?.message && (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.country_id?.message} />
                    </div>
                  )}
                </div>
              )}
            />
          </div>
          {country_name && country_name == USA && (
            <>
              <div className="row-primary">
                <h2>Select State</h2>

                <Controller
                  name="state_id"
                  control={control}
                  render={({ field }) => (
                    <div style={{ width: "100%" }}>
                      <AsyncPaginate
                        menuPlacement="auto"
                        styles={selectCustomStyles}
                        value={filterStates}
                        loadOptions={filteredStatesLoadOptions}
                        isClearable
                        escapeClearsValue
                        onChange={(obj) => {
                          setfilterStates(obj);
                          setAllCities(
                            obj != null
                              ? allStates?.find(
                                  (states) => states?.name == obj?.label
                                )?.cities
                              : []
                          );
                          field.onChange(obj?.value);
                        }}
                        additional={{
                          page: 1,
                        }}
                      />
                      {errors?.state_id?.message && (
                        <div style={{ marginBottom: 10 }}>
                          <ErrorMessage text={errors?.state_id?.message} />
                        </div>
                      )}
                    </div>
                  )}
                />
              </div>

              <div className="row-primary">
                <h2>City Name</h2>

                <Controller
                  name="city_name"
                  control={control}
                  render={({ field }) => (
                    <div className="w-100">
                      <input
                        className="input-in type_inp"
                        type="text"
                        name="city_name"
                        placeholder="Enter City Name"
                        {...field}
                      />
                      {errors?.city_name?.message && (
                        <div style={{ marginBottom: 10 }}>
                          <ErrorMessage text={errors?.city_name?.message} />
                        </div>
                      )}
                    </div>
                  )}
                />
              </div>

              <div className="row-primary">
                <h2>Zip Code</h2>
                <Controller
                  name="zip_code"
                  control={control}
                  render={({ field }) => (
                    <div className="w-100">
                      <input
                        className="input-in type_inp"
                        type="text"
                        name="zip_code"
                        placeholder="Zip Code"
                        {...field}
                      />
                      {errors?.zip_code?.message && (
                        <div style={{ marginBottom: 10 }}>
                          <ErrorMessage text={errors?.zip_code?.message} />
                        </div>
                      )}
                    </div>
                  )}
                />
              </div>
            </>
          )}

          <div className="row-primary">
            <h2>Timezone</h2>
            <Controller
              name="timezone_id"
              control={control}
              rules={{ required: "Please select a Timezone" }}
              render={({ field }) => (
                <div style={{ width: "100%" }}>
                  <AsyncPaginate
                    styles={selectCustomStyles}
                    value={filterTimezones}
                    loadOptions={filteredTimezonesLoadOptions}
                    isClearable
                    isDisabled={timezoneDisable}
                    placeholder="Select Timezone"
                    onChange={(selected) => {
                      setFilterTimezones(selected);
                      setValue("timezone_id", selected?.value || "");
                      field.onChange(selected?.value || "");
                    }}
                    additional={{ page: 1 }}
                  />
                  {errors?.timezone_id?.message && (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.timezone_id?.message} />
                    </div>
                  )}
                </div>
              )}
            />

        </div>

          <div className="row-primary">
            <h2>Select Languages *</h2>
            <Controller
              name="language_ids"
              required
              rules={{
                required: "Languages must be specified",
              }}
              control={control}
              render={({ field }) => (
                <div style={{ width: "100%" }}>
                  <div style={{ width: "100%" }}>
                    <AsyncPaginate
                      menuPlacement="auto"
                      isMulti
                      styles={{
                        ...selectCustomStyles,
                      }}
                      value={languageState}
                      loadOptions={filteredLanguagesLoadOptions}
                      isClearable
                      escapeClearsValue
                      onChange={(selected) => {
                        setLanguageState(selected);
                        field.onChange(selected.map((opt) => opt.value));
                      }}
                      additional={{
                        page: 1,
                      }}
                    />
                  </div>
                  {errors?.language_ids?.message && (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.language_ids?.message} />
                    </div>
                  )}
                </div>
              )}
            />
          </div>

          <div className="row-primary align-items-center">
            <h2 className="m-0">Credentials will be sent over email</h2>
            <label className="custom-checkbox checkbox">
              <input
                type="checkbox"
                name="credentials_send"
                checked={credentialsSend === 1 ? true : false}
                onChange={(e) => setCredentialsSend(e.target.checked ? 1 : 0)}
              />
              <span className="checkmark"></span>
            </label>
          </div>

          <div className="row-primary align-items-center">
            <h2 className="mt-0">Auto Assign </h2>
            <CustomSwitch
              labelText="auto_assign"
              checked={autoAssign == 1 ? true : false}
              handleChange={(checked) => setAutoAssign(checked ? 1 : 0)}
            />
          </div>
        </div>

        {/* filter area  */}
        <div className="row-primary row-r justify-content-between flex-row">
          <h2 className="fst-italic">Filters </h2>
        </div>
        <div className="Filter_wrapper">
          <div className="row-primary">
            <h2 className="col-6">US Based Interpreter</h2>
            <Controller
              name="us_based"
              control={control}
              render={({ field }) => (
                <div className="switch_row">
                  <Switch
                    checked={field.value === true}
                    onChange={(e) =>
                      handleChangeSwitch(e.target.checked, field.onChange)
                    }
                    value={true}
                  />
                </div>
              )}
            />
          </div>

          <div className="row-primary">
            <h2 className="col-6">Non US Based Interpreter</h2>
            <Controller
              name="non_us_based"
              control={control}
              render={({ field }) => (
                <div className="switch_row">
                  <Switch
                    checked={field.value === true}
                    onChange={(e) =>
                      handleChangeSwitch(e.target.checked, field.onChange)
                    }
                    value={true}
                  />
                </div>
              )}
            />
          </div>

          <div className="row-primary">
            <h2 className="col-6">English To Target Language</h2>
            <Controller
              name="english_to_target"
              control={control}
              render={({ field }) => (
                <div className="switch_row">
                  <Switch
                    checked={field.value === true}
                    onChange={(e) =>
                      handleChangeSwitch(e.target.checked, field.onChange)
                    }
                    value={true}
                  />
                </div>
              )}
            />
          </div>

          <div className="row-primary">
            <h2 className="col-6">Spanish To Target Language</h2>
            <Controller
              name="spanish_to_target"
              control={control}
              render={({ field }) => (
                <div className="switch_row">
                  <Switch
                    checked={field.value === true}
                    onChange={(e) =>
                      handleChangeSwitch(e.target.checked, field.onChange)
                    }
                    value={true}
                  />
                </div>
              )}
            />
          </div>

          <div className="row-primary">
            <h2 className="col-6">Court Certified</h2>
            <Controller
              name="court_certified"
              control={control}
              render={({ field }) => (
                <div className="switch_row">
                  <Switch
                    checked={field.value === true}
                    onChange={(e) =>
                      handleChangeSwitch(e.target.checked, field.onChange)
                    }
                    value={true}
                  />
                </div>
              )}
            />
          </div>

          <div className="row-primary">
            <h2 className="col-6">Medical Certified</h2>
            <Controller
              name="medical_certified"
              control={control}
              render={({ field }) => (
                <div className="switch_row">
                  <Switch
                    checked={field.value === true}
                    onChange={(e) =>
                      handleChangeSwitch(e.target.checked, field.onChange)
                    }
                    value={true}
                  />
                </div>
              )}
            />
          </div>
        </div>

        {/* filter area  */}

        <InterpreterRateSection
          control={control}
          errors={errors}
          watch={watch}
          setValue={setValue}
          ErrorMessage={ErrorMessage}
        />

        <div className="Form-footer footer_fullpage">
          <div className="row-primary m-0 align-items-center">
            {checkPermission("Status Interpreter") && (
              <>
                <h2 className="mt-0">Status</h2>
                <CustomSwitch
                  labelText="active"
                  checked={status == 1 ? true : false}
                  handleChange={(checked) => setStatus(checked ? 1 : 0)}
                />
              </>
            )}
          </div>

          <SubmitButton
            loader={loader}
            btnText={item?.id ? "Update" : "Create"}
          />
        </div>
      </form>
      {loader && <FullPageLoader />}
    </>
  );
}

export default AddInterpreter
